import type { ReactElement } from 'react';
import ConsentSiteSelector from '../../shared/agent-consent/SiteSelector/SiteSelector';
import { mcpSiteSelectorMessages } from './messages';
import { MCP_ROVO_DOC_URL } from '../mcpUrls';

const MCP_SITE_SELECT_INPUT_ID = 'oauth-consent-mcp-site-select';

const SiteSelector: React.FC = (): ReactElement => (
  <ConsentSiteSelector
    messages={mcpSiteSelectorMessages}
    noWorkspacesLearnMoreUrl={MCP_ROVO_DOC_URL}
    inputId={MCP_SITE_SELECT_INPUT_ID}
    isRequired
  />
);

export default SiteSelector;
